(function LoyaltyLoopResponses($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload(['/Clients/loyaltyloopResponses', '/Reports/welcomeHomeSurveys'], function _loyaltyLoopResponses() {
			$('.ll-response').on('click', function _showResponseDetails(e) {
				var $modal = $('.modal'),
					ll_id  = $(this).data('ll-id');

				e.preventDefault();
				$modal.find('.modal-body').text('Loading reservation details...');
				$modal.find('.modal-title').text('Survey Details');
				$modal.modal('show');

				Adzuki.Ajax.get('/Clients/loyaltyLoopResponseDetails/' + ll_id)
				.then(function _loyaltyLoopResponseDetails(data) {
					$modal.find('.modal-body').html(data);
				});
			});
		});
	});
}(jQuery, window.Adzuki || {}));